export const hasPermission = (permissions, keys = []) => {
  if (!permissions) return false;

  return keys.some((key) => {
    const section = permissions[key];
    if (!section) return false;

    // If it's a boolean (true/false) just return it
    if (typeof section === "boolean") return section;

    // If it's an object with read/write/edit/delete
    return (
      section.read ||
      section.write ||
      section.edit ||
      section.delete
    );
  });
};
